module.exports = __webpack_public_path__ + "media/assets/images/flags/gb-62fe7748dff567e300307e999284e578.svg";